import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { catchError, tap, throwError } from 'rxjs';
import { UserProfileVTO, UserProfileDTO, UpdatePasswordDTO, UserProfileLanguageDTO } from './profile-service.model';
import { AuthService } from './auth-service';
// import { CacheStorageService } from './cache/cache-storage.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private http = inject(HttpClient);
  private authService = inject(AuthService);
  // private cacheStorage = inject(CacheStorageService);
  private API = environment.userMgtApiUrl;

  getUserProfile() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.get<UserProfileVTO>(`${this.API}/profile`, { headers }).pipe(catchError(this.handleError));
  }

  updateUserProfile(profileData: UserProfileDTO) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.put<void>(`${this.API}/profile`, profileData, { headers }).pipe(
      tap(async () => {
        console.log('User profile updated successfully');
        // await this.cacheStorage.delete(`${this.API}/profile`);
      }),
      catchError(this.handleError),
    );
  }

  updateUserPassword(passwordData: UpdatePasswordDTO) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.patch<void>(`${this.API}/profile/password`, passwordData, { headers }).pipe(
      tap(() => console.log('Password updated successfully')),
      catchError(this.handleError),
    );
  }

  updateUserDefaultLanguage(languageData: UserProfileLanguageDTO) {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.patch<void>(`${this.API}/profile/language/default`, languageData, { headers }).pipe(
      tap(() => console.log('User default language updated successfully')),
      catchError(this.handleError),
    );
  }

  deleteUser() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.put<void>(`${this.API}/profile/delete`, {}, { headers }).pipe(
      tap(() => console.log('User deleted successfully')),
      catchError(this.handleError),
    );
  }

  restoreUser() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.put<void>(`${this.API}/profile/restore`, {}, { headers }).pipe(
      tap(() => console.log('User restored successfully')),
      catchError(this.handleError),
    );
  }

  reactivateUser() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.put<void>(`${this.API}/profile/reactivate`, {}, { headers }).pipe(
      tap(() => console.log('User reactivated successfully')),
      catchError(this.handleError),
    );
  }

  deactivateUser() {
    const token = this.authService.getAccessToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return this.http.put<void>(`${this.API}/profile/deactivate`, {}, { headers }).pipe(
      tap(() => console.log('User deactivated successfully')),
      catchError(this.handleError),
    );
  }


private handleError(error: HttpErrorResponse) {
  return throwError(() => error);
}
}
